'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';

export default function CertificationSection() {
  const [isWorkshopPage, setIsWorkshopPage] = useState(false);
  
  useEffect(() => {
    // Check if URL contains "/workshops"
    const currentPath = window.location.pathname;
    setIsWorkshopPage(currentPath.includes('/workshops'));
  }, []);

  return (
    <div className="w-full mt-16">
      <h2 className="text-[#002726] text-[28px] md:text-[32px] font-medium mb-3">
        Before you ask!
      </h2>
      
      <p className="text-[#002726] text-sm md:text-base mb-3">
        Yes! You will be certified for this program.
      </p>
      
      {/* Growth School Certificate */}
      <div className="mb-12">
        <div className="overflow-hidden md:p-4">
          <Image 
            src="https://d3kl8zsmmx4oop.cloudfront.net/GS_certificate_b91252c431_b546f36e85.png"
            alt="Growth School Certificate"
            width={1000}
            height={600}
            className="w-full h-auto"
          />
        </div>
      </div>
      
      {/* NSDC Certification - Hidden when URL contains /workshops */}
      {!isWorkshopPage && (
        <div className="mb-8">
          <h3 className="text-[#002726] text-sm md:text-base font-medium mb-4 uppercase">
            GOVERNMENT CERTIFIED
          </h3>
          <h2 className="text-[#002726] text-[28px] md:text-[32px] font-medium mb-6">
            Earn NSDC Certification
          </h2>
          
          <p className="text-[#002726] text-sm md:text-base mb-8">
            The National Skill Development Corporation (NSDC), under the Government of India, 
            promotes skill development. Your course is a part of NSDC programme and you'll receive 
            a certificate upon completion*
          </p>
          
          <h3 className="text-[#002726] text-base font-medium mb-4">
            Benefits of NSDC Certification:
          </h3>
          
          <ol className="list-decimal pl-6 mb-8 space-y-2">
            <li className="text-[#002726] text-sm md:text-base">
              Boost your career prospects with a certification acknowledged across India.
            </li>
            <li className="text-[#002726] text-sm md:text-base">
              Improves chances of employment and career advancement.
            </li>
            <li className="text-[#002726] text-sm md:text-base">
              Ensures top-quality education and training.
            </li>
          </ol>
          
          <p className="text-[#002726] mb-4 text-sm md:text-base">
            Register for NSDC certification today and advance your career with industry-recognized credentials.
          </p>
          
          <p className="text-[#002726] text-sm italic mb-8">
            * Subject to evaluation and attendance
          </p>
          
          <div className="overflow-hidden p-4 mb-4">
            <Image 
              src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/nsdc.webp"
              alt="NSDC Certificate Example"
              width={1000}
              height={600}
              className="w-full h-auto"
            />
          </div>
          
          <p className="text-[#002726] text-sm">
            For more details, visit: <a href="https://nsdcindia.org/" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">NSDC</a>
          </p>
        </div>
      )}
    </div>
  );
}